import React, { useEffect, useRef } from "react";

interface SliderInputProps {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
}

const SliderInput: React.FC<SliderInputProps> = ({ value, setValue }) => {
    const minValue = 50;
    const maxValue = 500;
    const bubbleRef = useRef<HTMLDivElement | null>(null);
    const sliderRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        const slider = sliderRef.current;
        const bubble = bubbleRef.current;

        if (slider && bubble) {
            const thumbSize = 25;
            const sliderWidth = slider.offsetWidth;
            const bubbleHalfWidth = bubble.offsetWidth / 2;
            const percent = (value - minValue) / (maxValue - minValue);
            // Thumb center travels from thumbSize/2 to sliderWidth-thumbSize/2
            const thumbCenterPx = (thumbSize / 2) + percent * (sliderWidth - thumbSize);
            // Clamp so bubble never overflows either edge of the slider
            const clampedPx = Math.max(bubbleHalfWidth, Math.min(sliderWidth - bubbleHalfWidth, thumbCenterPx));
            bubble.style.left = `${clampedPx}px`;
            bubble.style.transform = "translateX(-50%)";
            bubble.style.bottom = "35px";
        }
    }, [value]);

    return (
        <div className="slider-container">
            <input
                ref={sliderRef}
                type="range"
                min={minValue}
                max={maxValue}
                value={value}
                onChange={(e) => setValue(Number(e.target.value))}
                className="slider"
                aria-label="Player count slider"
            />
            <div className="bubble" ref={bubbleRef}>
                <span className="users-text">{value} Players</span>
            </div>
            <div className="slider-labels">
                <span>Under 100</span>
                <span>250</span>
                <span>500+</span>
            </div>
        </div>
    );
};

export default SliderInput;
